import React from 'react';
import { Cookies } from 'react-cookie';
import { Navigate } from 'react-router-dom';

const AuthProtected = (props: any) => {
  // const { userProfile, loading, token } = useProfile();
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  // useEffect(() => {
  //   if (userProfile && !loading && token) {
  //     setAuthorization(token);
  //   } else if (!userProfile && loading && !token) {
  //     dispatch(logoutUser());
  //   }
  // }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  if (!token) {
    return <Navigate to={{ pathname: '/login' }} />;
  }

  return <>{props.children}</>;
};

export default AuthProtected;
